export const data_research = 
[
    {
        "id": 0,
        "type": "Equipage",
        "description": "Construisez une flotte pour naviguer à travers les mers et les océans et devenir le capitaine le plus puissant.",
        "research": [
            {
                "id": "con-1",
                "name": "Laquais",
                "description": "Offrez vous les services des meilleurs laquais pour vos taches les plus ingrates.",
                "cost": 10,
                "experienceReward": 100,
                "time": 2000,
                "captainLevelRequired": 1,
                "ctaMessage": "Acheter",
                "level": 0,
                "goldAutoReward": 10,
            },
            {
                "id": "con-2",
                "name": "Matelot",
                "description": "En cas d'abordage, vous pourez compter sur vos matelot.",
                "cost": 200,
                "experienceReward": 2000,
                "time": 3000,
                "captainLevelRequired": 5,
                "ctaMessage": "Acheter",
                "level": 0,
                "goldAutoReward": 100,
            },
            {
                "id": "con-3",
                "name": "Timonier",
                "description": "Vous n'irez pas loin sans timonier pour diriger la navigation.",
                "cost": 1000,
                "experienceReward": 5000,
                "time": 6000,
                "captainLevelRequired": 10,
                "ctaMessage": "Acheter",
                "level": 0,
                "goldAutoReward": 300,
            },
            {
                "id": "con-4",
                "name": "Maître d'équipage",
                "description": "Le maître d'équipage est chargé de la discipline sur le navire. Il supervise les tâches effectuées.",
                "cost": 10500,
                "experienceReward": 10000,
                "time": 3000,
                "captainLevelRequired": 20,
                "ctaMessage": "Acheter",
                "level": 0,
                "goldAutoReward": 10050,
            },
            {
                "id": "con-5",
                "name": "Quartier-maître",
                "description": "Celui qui dirige l'équipage. Il supervise la gestion des provisions, et fait la jonction entre le capitaine et l'équipage.",
                "cost": 10500,
                "experienceReward": 15000,
                "time": 1,
                "captainLevelRequired": 30,
                "ctaMessage": "Acheter",
                "level": 0,
                "goldAutoReward": 200000,
            },
            {
                "id": "con-6",
                "name": "Canonnier",
                "description": "Le canonnier est le responsable de l'artillerie du navire, et donc des canons. Il dirige les tirs au moment d'une bataille et reçoit ses ordres du capitaine.",
                "cost": 100000500,
                "experienceReward": 20000000,
                "time": 1,
                "captainLevelRequired": 40,
                "ctaMessage": "Acheter",
                "level": 0,
                "goldAutoReward": 400000,
            },
            {
                "id": "con-7",
                "name": "Maître d'armes",
                "description": "Le maître d'armes est en charge de l'inventaire des armes présentes à bord du navire.",
                "cost": 1000000000,
                "experienceReward": 500000000,
                "time": 5000,
                "captainLevelRequired": 50,
                "ctaMessage": "Acheter",
                "level": 0,
                "goldAutoReward": 1000000000,
            },
            {
                "id": "con-8",
                "name": "Cuisinier",
                "description": "Le membre le plus important de votre flotte, celui qui remplira l'estomac de votre équipage.",
                "cost": 25000000000,
                "experienceReward": 100000000,
                "time": 12000,
                "captainLevelRequired": 60,
                "ctaMessage": "Acheter",
                "level": 0,
                "goldAutoReward": 2000000000,
            }
        ]
    },
    {
        "id": 1,
        "type": "Navires",
        "description": "",
        "research": [
            {
                "id": "nav-1",
                "name": "Barque",
                "description": "Pouvant se faufiler aisément entre les îles, la barque est un navire de petite taille, mais rapide.",
                "cost": 5000,
                "experienceReward": 750,
                "time": 5000,
                "captainLevelRequired": 5,
                "ctaMessage": "Améliorer",
                "level": 0,
                "goldAutoReward": 3000,
            },
            {
                "id": "nav-2",
                "name": "Sloop",
                "description": "Plus petit que la barque, facilement maniable et extrêmement rapide",
                "cost": 25000,
                "experienceReward": 5000,
                "time": 2000,
                "captainLevelRequired": 15,
                "ctaMessage": "Améliorer",
                "level": 0,
                "goldAutoReward": 1500,
            },
            {
                "id": "nav-3",
                "name": "Brigantin",
                "description": " Ce navire est destiné pour de longs voyages, et est pratique pour traverser de nombreuses intempéries. ",
                "cost": 100000,
                "experienceReward": 10750,
                "time": 18000,
                "captainLevelRequired": 25,
                "ctaMessage": "Améliorer",
                "level": 0,
                "goldAutoReward": 100000,
            },
            {
                "id": "nav-4",
                "name": "Caravelle",
                "description": " Large, peu armé et mesurant jusqu’à 80 pieds de long, ce navire marchand est conçu pour transporter une cargaison importante. ",
                "cost": 250000,
                "experienceReward": 20000,
                "time": 20000,
                "captainLevelRequired": 35,
                "ctaMessage": "Améliorer",
                "level": 0,
                "goldAutoReward": 150000,
            },
            {
                "id": "nav-5",
                "name": "Frégate",
                "description": "Grand bateau naviguant dans les Caraïbes, la frégate peut également accueillir une centaine d’hommes. Il comporte généralement entre 22 et 28 canons. ",
                "cost": 500000000,
                "experienceReward": 100000,
                "time": 30000,
                "captainLevelRequired": 50,
                "ctaMessage": "Améliorer",
                "level": 0,
                "goldAutoReward": 750000,
            }
        ]
    },
    {
        "id": 2,
        "type": "Amélioration",
        "description": "De superbes améliorations pour vous améliorer",
        "research": [
            {
                "id": "am-2",
                "name": "Click efficace",
                "description": "Pour augmenter votre éfficacité de clic",
                "cost": 10,
                "experienceReward": 50,
                "captainLevelRequired": 1,
                "ctaMessage": "Améliorer",
                "level": 0,
                "effectMessage": "Gain par Click = 1.5 * Click efficace",
            },
            {
                "id": "am-3",
                "name": "Qualité nutritive",
                "description": "Construisez un équipage survitaminé",
                "cost": 200000,
                "experienceReward": 10000,
                "captainLevelRequired": 15,
                "ctaMessage": "Améliorer",
                "level": 0,
            },
            {
                "id": "am-1",
                "name": "Navigation",
                "description": "Améliore le rendement de vos navires",
                "cost": 100,
                "experienceReward": 25,
                "captainLevelRequired": 20,
                "ctaMessage": "Améliorer",
                "level": 0,
            }
        ]
    },
    {
        "id": 3,
        "type": "Laboratoire",
        "description": "Votre labo de recherche personnel",
        "research": [
            {
                "id": "lab-1",
                "name": "Matière recyclée",
                "description": "Diminue les coûts d'achat.",
                "cost": 2500,
                "experienceReward": 200,
                "time": 10,
                "captainLevelRequired": 7,
                "ctaMessage": "Rechercher",
                "level": 0,
                "effectMessage": "Coût diminué de 0.01 * Matière recyclée",
            },
            {
                "id": "lab-2",
                "name": "Système de consignation",
                "description": "Rend le stockage plus efficace.",
                "cost": 10000,
                "experienceReward": 1000,
                "time": 10,
                "captainLevelRequired": 10,
                "ctaMessage": "rechercher",
                "level": 0,
            }
        ]
    }
]
